<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須
    .register-key
      slot(name="optionText")

    .register-value 
      select.register-form.input-select(
        v-model="_value"
        :name="name"
        v-validate="validationRules"
        :data-vv-as="(validationKeyName) ? validationKeyName : keyName"
        :style="styles"
        :class="{ noinput: (required == true && _value == null) }"
        @change="onChange"
      )
        option(v-for="option in options" :value="option.value") {{ option.label }}

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント(セレクトボックス入力)
 *
 * - セレクトボックスの入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputSelect extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  /** リスト項目 */
  @Prop()
  options!: Array<{ value: number | string; label: string }>;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }

  public onChange() {
    this.$emit("change", this.value);
    return;
  }
}
</script>

<style lang="scss" scoped>
.input-select {
  min-width: 340px;
}
</style>
